import { render } from "./MakeCreditNotePage.vue?vue&type=template&id=e6158a9a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__